import { render, staticRenderFns } from "./NormalChallengeStartModal.vue?vue&type=template&id=4cf73af0"
import script from "./NormalChallengeStartModal.vue?vue&type=script&lang=js"
export * from "./NormalChallengeStartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports